import _slicedToArray from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import loader from '@monaco-editor/loader';
import { useState } from 'react';
import useMount from '../useMount/index.js';
function useMonaco() {
  var _useState = useState(loader.__getMonacoInstance()),
    _useState2 = _slicedToArray(_useState, 2),
    monaco = _useState2[0],
    setMonaco = _useState2[1];
  useMount(function () {
    var cancelable;
    if (!monaco) {
      cancelable = loader.init();
      cancelable.then(function (monaco) {
        setMonaco(monaco);
      });
    }
    return function () {
      var _cancelable;
      return (_cancelable = cancelable) === null || _cancelable === void 0 ? void 0 : _cancelable.cancel();
    };
  });
  return monaco;
}
export default useMonaco;